import { Star } from "lucide-react";

export function Stars({ value, onPick, size = 16, testid = "stars" }) {
  return (
    <span className="stars" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => {
        const icon = <Star size={size} fill={n <= value ? "currentColor" : "none"} />;
        return onPick ? (
          <button key={n} type="button" className={`star-btn ${n <= value ? "on" : ""}`} data-testid={`${testid}-${n}`} aria-label={`${n}`} onClick={() => onPick(n)}>{icon}</button>
        ) : <span key={n} className={n <= value ? "on" : ""}>{icon}</span>;
      })}
    </span>
  );
}
